import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import VehicleRegistrationService from "../services/vehicleRegistrationService";
import VehicleTypeService from "../services/VehicleTypeService";
import VendorCategoryService from "../services/VendorCategoryService";
import VendorService from "../services/VendorServices";
import ReadingTypeService from "../services/ReadingTypeService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";
import DevOpsLoader from "../components/DevOpsLoader";
import MessageDialog from "../components/MessageDialog";


export default function AddVehicleRegistration() {
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [readingTypes, setReadingTypes] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendorCategory, setSelectedVendorCategory] = useState("");
  const [showVendor, setShowVendor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [editMode, setEditMode] = useState(false);

  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm({ mode: "onChange" });

  const ownerShipType = watch("ownerShipType");
  const vendorCatWatch = watch("vendorCategoryId");

  // Show Vendor dropdown when Lease is selected
  // useEffect(() => {
  //   if (ownerShipType === "Lease") {
  //     setShowVendor(true);
  //     fetchVendorCategories();
  //   } else {
  //     setShowVendor(false);
  //     setValue("vendorCategoryId", "");
  //     setValue("vendorId", "");
  //     setSelectedVendorCategory("");
  //     setVendors([]);
  //   }
  // }, [ownerShipType]);

  // useEffect(() => {

  //   if (ownerShipType === "Lease") {

  //     setShowVendor(true);
  //     fetchVendorCategories();

  //   } else {

  //     setShowVendor(false);

  //     setValue("vendorCategoryId", "");
  //     setValue("vendorId", "");

  //     //  clear reading type for Transport
  //     // if (ownerShipType === "Transport") {
  //     //   setValue("readingType", "");
  //     // }

  //     setSelectedVendorCategory("");
  //     setVendors([]);
  //   }

  // }, [ownerShipType, setValue]);


  useEffect(() => {

    if (ownerShipType === "Lease") {

      setShowVendor(true);
      fetchVendorCategories();

    } else {

      setShowVendor(false);

      //  clear vendor fields
      if (watch("vendorCategoryId")) {
        setValue("vendorCategoryId", "");
      }

      if (watch("vendorId")) {
        setValue("vendorId", "");
      }



      setSelectedVendorCategory("");
      setVendors([]);
    }

  }, [ownerShipType]);

  // Fetch Vehicle Types
  const fetchVehicleTypes = async () => {
    try {
      const res = await VehicleTypeService.getActiveVehicleTypes();
      const data = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      setVehicleTypes(data);
    } catch (err) {
      console.error("Error fetching vehicle types:", err);
      setVehicleTypes([]);
    }
  };

  // Fetch Reading Types
  const fetchReadingTypes = async () => {
    try {
      const res = await ReadingTypeService.getActive();
      const data = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      setReadingTypes(data);
    } catch (err) {
      console.error("Error fetching reading types:", err);
      setReadingTypes([]);
    }
  };

  // Fetch Vendor Categories
  const fetchVendorCategories = async () => {
    try {
      const res = await VendorCategoryService.getActive();
      const data = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      setVendorCategories(data);
    } catch (err) {
      console.error("Error fetching vendor categories:", err);
      setVendorCategories([]);
    }
  };

  // Fetch Vendors by Category
  const fetchVendorsByCategory = async (categoryId) => {
    if (!categoryId) {
      setVendors([]);
      return;
    }
    try {
      const res = await VendorService.getByCategory(categoryId);
      const data = Array.isArray(res?.data) ? res.data : [];
      setVendors(data);
    } catch (err) {
      console.error("Error fetching vendors:", err);
      setVendors([]);
    }
  };

  const prevVendorCategoryRef = useRef(null);

  // Watch vendor category changes
  useEffect(() => {
    if (vendorCatWatch) {
      setSelectedVendorCategory(vendorCatWatch);
      fetchVendorsByCategory(vendorCatWatch);

      // Only clear vendorId if user manually changed vendor category to a different category
      if (prevVendorCategoryRef.current !== null && prevVendorCategoryRef.current !== vendorCatWatch) {
        setValue("vendorId", "");
      }
      prevVendorCategoryRef.current = vendorCatWatch;
    } else {
      if (prevVendorCategoryRef.current !== null) {
        setValue("vendorId", "");
      }
      setVendors([]);
      prevVendorCategoryRef.current = vendorCatWatch;
    }
  }, [vendorCatWatch, setValue]);

  // Initialize data
  useEffect(() => {
    const init = async () => {
      await Promise.all([fetchVehicleTypes(), fetchReadingTypes(), fetchVendorCategories()]);
      if (id) {
        setEditMode(true);
        fetchVehicleById(id);
      }
    };
    init();
  }, [id]);

  // Fetch vehicle by ID for edit
  const fetchVehicleById = async (vehicleId) => {
    setEditLoading(true); // 🔄 START LOADING
    try {
      const res = await VehicleRegistrationService.getById(vehicleId);
      const record = res?.data;
      if (record) {
        if (record.ownerShipType === "Lease") setShowVendor(true);

        const vCatId = record.vendorCategoryId ? String(record.vendorCategoryId) : "";
        const vId = record.vendorId ? String(record.vendorId) : "";

        if (vCatId) {
          setSelectedVendorCategory(vCatId);
          prevVendorCategoryRef.current = vCatId;
          try {
            const vendorRes = await VendorService.getByCategory(vCatId);
            const vendorList = Array.isArray(vendorRes?.data) ? vendorRes.data : [];
            setVendors(vendorList);
          } catch (vErr) {
            console.error("Error fetching vendors for category:", vErr);
          }
        }

        reset({
          vehicleTypeId: record.vehicleTypeId ? String(record.vehicleTypeId) : "",
          vehicleName: record.vehicleName || "",
          registrationNo: record.registrationNo || "",
          readingType: record.readingType || "",
          ownerShipType: record.ownerShipType || "",
          vendorCategoryId: vCatId,
          vendorId: vId,
        });

        if (vCatId) setValue("vendorCategoryId", vCatId);
        if (vId) setValue("vendorId", vId);
      } else {
        showMessage("Failed to load vehicle details.", "error");
      }
    } catch (err) {
      console.error(err);
      showMessage("Error fetching vehicle details.", "error");
    } finally {
      setEditLoading(false); // ✅ STOP LOADING
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const login = StorageService.loginData();
      const activeCompany = StorageService.activeCompany();
      if (!activeCompany?.companyId) {
        showMessage("Please select a company first!", "error");
        setLoading(false);
        return;
      }

      const payload = {
        ...data,
        vehicleTypeId: Number(data.vehicleTypeId),
        vendorId: data.vendorId ? Number(data.vendorId) : null,
        readingType: data.readingType,
        ownerShipType: data.ownerShipType,
        vendorCategoryName: data.vendorCategoryName,
        vendorName: data.vendorName,
        isActive: 1,
        createdBy: login.employeeId,
        updatedBy: login.employeeId,
        companyId: activeCompany.companyId,
        createdDate: new Date().toISOString(),
      };
      let result;
      if (id) {
        result = await VehicleRegistrationService.update(id, payload);
      } else {
        result = await VehicleRegistrationService.create(payload);
      }

      if (result?.status === false || result?.success === false) {
        showMessage(result?.message || "Registration number already exists!", "error");
        setLoading(false);
        return;
      }

      showMessage(id ? "Record updated successfully" : "Record saved successfully", "success");
      setTimeout(() => navigate("/cpnl/Vehicles/view"), 1500);

    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || err.message || "Error saving vehicle registration!";
      showMessage(errMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate("/cpnl/Vehicles/view");

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Vehicle Registration" : "Vehicle Registration"}
        secondTitle="Masters"
      />

      <div className="row">
        <div className="card p-4 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"} d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage} />
            </div>
          )} */}
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          <DevOpsLoader showLoader={editLoading}></DevOpsLoader>

          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Vehicle Type + Vehicle Name */}
            <div className="row">
              <div className="mb-3 col-md-6">
                <label className="form-label">Vehicle Type <span style={{ color: "red" }}>*</span></label>
                <select className="form-select" {...register("vehicleTypeId", { required: "Vehicle Type is required" })}>
                  <option value="">Select Vehicle Type</option>
                  {vehicleTypes.map((type) => (
                    <option key={type.id} value={String(type.id)}>
                      {type.vehicleType || type.name}
                    </option>
                  ))}
                </select>
                {errors.vehicleTypeId && <small className="text-danger">{errors.vehicleTypeId.message}</small>}
              </div>

              <div className="mb-3 col-md-6">
                <label className="form-label">Vehicle Owner Name <span style={{ color: "red" }}>*</span></label>
                <input type="text" className="form-control" {...register("vehicleName", { required: "Vehicle Owner Name is required" })} />
                {errors.vehicleName && <small className="text-danger">{errors.vehicleName.message}</small>}
              </div>
            </div>

            {/* Registration No + Reading Type */}
            <div className="row">
              <div className="mb-3 col-md-6">
                <label className="form-label">Registration No <span style={{ color: "red" }}>*</span></label>
                <input type="text" className="form-control" {...register("registrationNo", { required: "Registration No is required" })}
                  onInput={(e) => {
                    e.target.value = e.target.value.toUpperCase();
                  }}
                />
                {errors.registrationNo && <small className="text-danger">{errors.registrationNo.message}</small>}
              </div>

              <div className="mb-3 col-md-6">
                <label className="form-label">Reading Type <span style={{ color: "red" }}>*</span></label>
                <select
                  className="form-select"
                  {...register("readingType", { required: "Reading Type is required" })}
                >
                  <option value="">Select Reading Type</option>
                  {readingTypes.map((rt) => (
                    <option key={rt.id} value={rt.readingType}>{rt.readingType}</option>
                  ))}
                </select>
                {errors.readingType && <small className="text-danger">{errors.readingType.message}</small>}
              </div>
            </div>

            {/* Ownership + Vendor Category + Vendor */}
            <div className="row">
              <div className="mb-3 col-md-6">
                <label className="form-label">Ownership <span style={{ color: "red" }}>*</span></label>
                <select className="form-select" {...register("ownerShipType", { required: "Ownership is required" })}>
                  <option value="">Select Ownership</option>
                  <option value="Self">Self</option>
                  <option value="Company">Company</option>
                  <option value="Lease">Lease</option>
                  <option value="Transport">Transport</option>
                  <option value="Other">Other</option>
                </select>
                {errors.ownerShipType && <small className="text-danger">{errors.ownerShipType.message}</small>}
              </div>

              {showVendor && (
                <>
                  {/* Vendor Category */}
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Vendor Category <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" {...register("vendorCategoryId")}>
                      <option value="">Select Vendor Category</option>
                      {vendorCategories.map((vc) => (
                        <option key={vc.id} value={String(vc.id)}>{vc.vendorCategoryName || vc.categoryName}</option>
                      ))}
                    </select>
                  </div>

                  {/* Vendor */}
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Vendor <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" {...register("vendorId")} disabled={!selectedVendorCategory}>
                      <option value="">Select Vendor</option>
                      {vendors.map((v) => (
                        <option key={v.id} value={String(v.id)}>{v.vendorName}</option>
                      ))}
                    </select>
                    {errors.vendorId && <small className="text-danger">{errors.vendorId.message}</small>}
                  </div>
                </>
              )}
            </div>

            {/* Buttons */}
            <div>
              <button type="submit" className="btn btn-primary btn-sm me-2">
                {loading ? (editMode ? "Updating..." : "Saving...") : editMode ? "Update" : "Save"}
                <i className="ti ti-circle-check me-1"></i>
              </button>
              <button type="button" className="btn btn-secondary btn-sm" onClick={handleCancel}>Cancel
                <i className="ti ti-cancel me-1"></i>
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
}
